import 'antd/dist/reset.css';

import { PropsWithChildren } from 'react';

import { ConfigProvider, message } from 'antd';

import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';

import GlobalStyles from '@/GlobalStyles';
import { setInitialGlobalClassTheme } from '@/helpers/theme';
import useGetSubdomainTheme from '@/hooks/useGetSubdomainTheme';
import useThemeMode from '@/hooks/useThemeMode';
import useThemeSelector from '@/hooks/useThemeSelector';

message.config({
  maxCount: 3,
  prefixCls: 'darktheme'
});

const ThemeProvider = ({ children }: PropsWithChildren) => {
  const { mode } = useThemeMode();
  const { theme, isLoading } = useGetSubdomainTheme();

  const { antdTheme, emotionTheme } = useThemeSelector(mode, theme);

  if (isLoading) {
    return null;
  }

  setInitialGlobalClassTheme();

  return (
    <ConfigProvider theme={antdTheme}>
      <EmotionThemeProvider theme={emotionTheme}>
        <GlobalStyles />
        {children}
      </EmotionThemeProvider>
    </ConfigProvider>
  );
};

export default ThemeProvider;
